import styles from './notifications-panel.module.scss';

/**
 * The loading state (Figma 621:554520).
 *
 * Deliberately mirrors the loaded panel's geometry — date pill, 36px badge, two text lines, time
 * bar — including the tint on the rows that will come back unread, so the panel does not resize
 * or reflow when the data lands.
 */
export function NotificationsPanelSkeleton() {
  return (
    <div className={styles.panel} aria-busy="true" aria-label="Loading notifications">
      <div className={styles.scroller}>
        {[
          { key: 'a', rows: [true, true] },
          { key: 'b', rows: [false, false] },
        ].map((group) => (
          <section key={group.key} className={styles.group}>
            <span className={styles.skeletonDate} />
            {group.rows.map((unread, index) => (
              <div
                key={index}
                className={[styles.skeletonRow, unread ? styles.skeletonUnread : undefined]
                  .filter(Boolean)
                  .join(' ')}
              >
                <span className={styles.skeletonBadge} />
                <span className={styles.skeletonLines}>
                  <span className={styles.skeletonTitle} />
                  <span className={styles.skeletonBody} />
                  <span className={styles.skeletonBodyShort} />
                </span>
                <span className={styles.skeletonTime} />
              </div>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
